// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__Uq21P","wrapper":"layout_wrapper__Fboob","main":"layout_main__OfCV9"};